import React, { useState } from 'react';
import ReactQuill from 'react-quill-new';
import 'react-quill-new/dist/quill.snow.css';
import '../../../styles/rich-editor.css';
import { SectionCard, TextField } from '../../../components/admin/EditorFields';
import { FileText, ShieldCheck, Cookie } from 'lucide-react';

const QUILL_MODULES = {
  toolbar: [
    [{ header: [2, 3, false] }],
    ['bold', 'italic', 'underline', 'strike'],
    [{ list: 'ordered' }, { list: 'bullet' }],
    [{ align: [] }],
    ['blockquote', 'link'],
    ['clean'],
  ],
  clipboard: { matchVisual: false },
};

const QUILL_FORMATS = [
  'header', 'bold', 'italic', 'underline', 'strike',
  'list', 'bullet', 'align', 'blockquote', 'link',
];

const TABS = [
  { key: 'mentions', label: 'Mentions légales', icon: FileText, help: "Éditeur du site, hébergeur, propriété intellectuelle." },
  { key: 'privacy', label: 'Confidentialité (RGPD)', icon: ShieldCheck, help: "Traitement des données personnelles, droits des utilisateurs." },
  { key: 'cookies', label: 'Cookies', icon: Cookie, help: "Politique de gestion des cookies." },
];

export default function LegalEditor({ data, setData }) {
  const [tab, setTab] = useState('mentions');

  const updatePage = (key, field, value) => {
    setData((d) => ({
      ...d,
      [key]: { ...(d?.[key] || {}), [field]: value },
    }));
  };

  const current = data?.[tab] || {};

  return (
    <div className="space-y-5">
      {/* Onglets */}
      <div className="flex flex-wrap gap-2">
        {TABS.map((t) => {
          const active = t.key === tab;
          return (
            <button
              key={t.key}
              type="button"
              onClick={() => setTab(t.key)}
              data-testid={`legal-tab-${t.key}`}
              className={`inline-flex items-center gap-2 px-4 py-2 rounded-full text-sm font-semibold border transition-colors ${
                active
                  ? 'bg-sky-950 text-white border-sky-950 shadow-sm'
                  : 'bg-white text-sky-800 border-sky-200 hover:border-sky-400'
              }`}
            >
              <t.icon className="w-4 h-4" />
              {t.label}
            </button>
          );
        })}
      </div>

      <SectionCard title={TABS.find((t) => t.key === tab)?.label}>
        <p className="text-xs text-slate-500 mb-4">{TABS.find((t) => t.key === tab)?.help}</p>

        <TextField
          label="Titre affiché"
          value={current.title}
          onChange={(v) => updatePage(tab, 'title', v)}
        />

        <TextField
          label="Date de mise à jour"
          value={current.updatedAt}
          onChange={(v) => updatePage(tab, 'updatedAt', v)}
          hint="Exemple : Février 2026"
        />

        <div className="mt-4">
          <label className="text-xs font-semibold uppercase tracking-wider text-slate-600">Contenu</label>
          <p className="text-xs text-slate-500 mt-1 mb-2">
            Utilisez les boutons de la barre d'outils pour mettre en forme (titres H2/H3, gras, listes, liens…).
          </p>
          <div className="rounded-xl border border-sky-200 overflow-hidden bg-white" data-testid={`legal-editor-${tab}`}>
            <ReactQuill
              key={tab}
              theme="snow"
              value={current.content || ''}
              onChange={(html) => updatePage(tab, 'content', html)}
              modules={QUILL_MODULES}
              formats={QUILL_FORMATS}
              placeholder="Rédigez le contenu ici…"
            />
          </div>
        </div>
      </SectionCard>
    </div>
  );
}
